<template>
	<div class="right-tabs-cls">
		<div v-if="list.length > 0">
			<el-tabs v-model="active" @tab-click="handleTabsClick" @tab-remove="handleTabsRemove" type="card" closable>
				<template>
					<el-tab-pane :label="isShowPhone ? item.phoneNumber : hiddenPhone(item.phoneNumber)" :name="item.histId" v-for="item in list" :key="item.histId">
						<CallInfo :histId="item.histId" />
						<Resemblance :row="item" />
						<!-- <CustomerInfo sourceType="tel" :customerId="item.custId" :tuId="item.iaId" /> -->
					</el-tab-pane>
				</template>
			</el-tabs>
		</div>
		<el-empty v-else description="暂无数据"></el-empty>
	</div>
</template>

<script>
import CallInfo from "./CallInfo";
import CustomerInfo from "components/CustomerInfo/index";
import Resemblance from "./Resemblance";
import { mapGetters } from 'vuex';
export default {
	props: ['row', 'activeName'],
	components: {CallInfo, CustomerInfo, Resemblance},
	computed: {
		...mapGetters([
			'userInfo',
			'isShowPhone'
		])
	},
	data() {
		return {
			list: [],
			active: ''
		}
	},
	watch: {
		row: {
			handler: function(val) {
				if(val) {
					const result = this.list.some(item => item.histId === val.histId);
					if(result) return;
					if(this.list.length === 20) {
						this.list.splice(0, 1);
					}
					this.list.push(val);
				}
			},
			immediate: true,
			deep: true
		},
		activeName: {
			handler: function(val) {
				this.active = val;
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		handleTabsClick(tab) {
			this.$emit('handleActiveNameRight', tab.name);
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		handleTabsRemove(targetName) {
			let tabs = this.list;
			let active = this.active;
			if (active === targetName) {
				tabs.forEach((tab, index) => {
					if (tab.histId === targetName) {
						let nextTab = tabs[index + 1] || tabs[index - 1];
						if (nextTab) {
							active = nextTab.histId;
						}
					}
				});
			}
			this.active = active;
			this.list = tabs.filter(tab => tab.histId !== targetName);
			
			this.$emit('handleActiveNameRight', active, this.list.length);
		},
	}
}
</script>

<style lang="scss" scoped>
.right-tabs-cls {
	width: 100%;
	height: 100%;
	padding: 0 12px;
	box-sizing: border-box;

	::v-deep .el-tabs {

		& .el-tabs__header {

			& .el-tabs__nav {
				border-radius: 0;
			}
		}
	}

	::v-deep .el-empty {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}
}
</style>